module.exports = __webpack_public_path__ + "img/bettermynd-logo@2x.1bbbdfbd.png";